<template>
  <div class="main-wrap">
    <div class="main">
      <div class="main-line"></div>
      <div class="main-content">
        <div class="title-box">
          <span class="type">考试</span>
          <span class="title">
            <span>{{ testInfo.test_title }}</span>
          </span>
        </div>
        <div class="info">
          <p v-for="item in testInfo.testInfo" :key="item.id">
            {{ item.label }}：{{ item.value }}{{ item.unit }}
          </p>
        </div>
        <div
          class="info"
          v-if="testInfo.test_status != 0 && testInfo.test_status != -1"
        >
          <p v-for="item in testInfo.packageInfo" :key="item.id">
            {{ item.label }}：{{ item.value }}
          </p>
        </div>
        <div class="info" v-if="testInfo.start_time">
          <p>考试时间：{{ testInfo.start_time }} ~ {{ testInfo.end_time }}</p>
        </div>
      </div>
      <div
        v-if="!(testInfo.has_expired == 1 && !testInfo.has_tested_num)"
        class="btn-box"
      >
        <p v-if="testInfo.is_apply == 0" class="normal" @click="apply()">
          报名考试
        </p>
        <div class="test-btn" v-else>
          <p class="normal" @click="seeDetail" v-if="canDetail()">查看详情</p>
          <p class="normal" @click="inToTest" v-if="canTest()">
            {{ testInfo.test_status == 0 ? "继续考试" : "参加考试" }}
          </p>
        </div>
        <div
          v-if="
            (testInfo.test_status == 1 || testInfo.test_status == 3) &&
            testInfo.show_answer_rule == 1
          "
          class="point"
        >
          <p>{{ testInfo.get_score }}</p>
          <img src="@/modules/stu/images/exam/package/score-line-new.png" />
        </div>
      </div>
    </div>
    <TestCheckModal ref="checkModal" />
  </div>
</template>

<script>
import TestCheckModal from "@/modules/stu/views/member/components/TestCheckModal";
export default {
  name: "NoticeTestCard",
  components: {
    TestCheckModal,
  },
  props: {
    testInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      remindType: {},
      courseList: [],
      testCondition: {},
      showModal: false,
      showOverModal: false,
    };
  },
  methods: {
    async apply() {
      await this.$http.get(`/api/app/test/applyPublicTest/${this.testInfo.id}`);
      this.$emit("applySuccess");
      this.$message.success("报名成功");
    },
    async inToTest() {
      //先校验是否达到考试条件，如果没有
      await this.$refs.checkModal.init(this.testInfo.id);
      //继续考试，不需要进去试卷介绍页
      if (this.testInfo.test_status == 0) {
        this.$router.push({
          name: "TestDo",
          query: {
            id: this.testInfo.report_id,
            package_id: this.testInfo.id,
          },
        });
        return;
      }
      //否则去考试
      this.$router.push({
        name: "TestDetail",
        query: { id: this.testInfo.id },
      });
    },
    seeDetail() {
      this.$router.push({
        name: "TestReport",
        params: {
          id: this.testInfo.current_report_id,
        },
      });
      //进入试卷详情页
    },
    //判断是否可以参加考试  未提交，待考试，已批阅，已提交（不需要人工批阅）并且考试次数没有用完，并且未过期，都可以参加考试
    canTest() {
      if (
        this.testInfo.test_status != 2 &&
        (this.testInfo.times == 0 ||
          this.testInfo.has_tested_num < this.testInfo.times) &&
        this.testInfo.has_expired == 0
      ) {
        return true;
      }
      return false;
    },
    //是否可以查看详情  已经作答过
    canDetail() {
      if (this.testInfo.has_tested_num >= 1) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.main-wrap {
  flex: 1;
  margin-bottom: 35px;
  .main {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border: 1px solid #e6e6e6;
    border-left: none;
    .main-line {
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 100%;
      background: linear-gradient(115deg, #ff7940 0%, #ffcf4f 100%);
      box-shadow: 0px 2px 4px 0px rgba(255, 157, 70, 0.1);
    }
    .main-content {
      .title-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .type {
          width: 48px;
          height: 22px;
          margin-right: 18px;
          background: rgba(255, 127, 36, 0.1);
          border-radius: 4px;
          text-align: center;
          font-size: 12px;
          color: #bb1c20;
          line-height: 22px;
          &.red {
            background: rgba(255, 36, 36, 0.1);
            color: #ff2424;
          }
          &.green {
            background: rgba(28, 204, 102, 0.1);
            color: #1ccc66;
          }
          &.grey {
            background: rgba(153, 153, 153, 0.1);
            color: #999;
          }
        }
        .title {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: Regular;
          text-align: center;
          color: #333333;
          line-height: 20px;
        }
      }
      .info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 10px;
        p {
          margin-right: 32px;
          font-size: 12px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: Regular;
          text-align: left;
          color: #999999;
          line-height: 17px;
        }
      }
    }
    .btn-box {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      height: 100%;
      .test-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
      .normal {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 98px;
        height: 36px;
        margin-left: 12px;
        background: #ffffff;
        border: 1px solid #bfbfbf;
        border-radius: 19px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
      }
      .point {
        display: flex;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: 22px;
        p {
          font-size: 40px;
          font-family: Slidechunfeng, Slidechunfeng-Regular;
          font-weight: Regular;
          text-align: center;
          color: #ff1f49;
          line-height: 48px;
          text-shadow: 0px 2px 4px 0px rgba(253, 90, 38, 0.1);
        }
        img {
          width: 50px;
          height: 16px;
        }
      }
      .small {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 98px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #bfbfbf;
        border-radius: 18px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
      }
    }
  }
}
</style>
